module.exports = __webpack_public_path__ + "img/text-icon.88ff47f2.svg";